import links from '../../../config'

const { domain: origin } = links

export const matchPath = (arr) => {
  const { pathname } = window.location
  const ucPath = pathname.toUpperCase()

  const activeLink = arr.find(({ url }) => {
    const subdomain = url.replace(origin, '').toUpperCase()
    return ucPath.includes(subdomain)
  })

  return activeLink
}
